import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WorkOrdersService {

  private _baseUrl: string = "";
  private _controllerName: string = "";

  constructor(private _http: HttpClient) {
    this._baseUrl = environment.apiUrl;
    this._controllerName = "WorkOrders"
  }

  // private getHeaders(): HttpHeaders{
  //   return new HttpHeaders({
  //     'Content-Type': 'application/json',
  //     'Authorization': `Bearer ${this.getToken()}`
  //   })
  // }

  insert(payload: any): Observable<any> {
    return this._http.post<any>(`${this._baseUrl}/${this._controllerName}`, payload).pipe(catchError(this.handleErrors))
  }

  update(id: number, payload: any): Observable<any> {
    return this._http.put<any>(`${this._baseUrl}/${this._controllerName}/${id}`, payload).pipe(catchError(this.handleErrors))
  }

  delete(id: number): Observable<any> {
    return this._http.delete<any>(`${this._baseUrl}/${this._controllerName}/${id}`).pipe(catchError(this.handleErrors))
  }

  getAll(thirdPartyId?: number, status?: number): Observable<any> {
    // Construir la URL con parámetros de consulta si thirdPartyId está presente
    let url = `${this._baseUrl}/${this._controllerName}`;
    const params = [];

    if (thirdPartyId) {
      params.push(`thirdPartyId=${encodeURIComponent(thirdPartyId)}`);
    }
    if (status) {
      params.push(`status=${encodeURIComponent(status)}`);
    }

    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }

    return this._http.get<any>(url).pipe(catchError(this.handleErrors));
  }

  getById(id: number): Observable<any> {
    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}/${id}`).pipe(catchError(this.handleErrors))
  }

  // Métodos de anulación
  cancelWorkOrder(id: number, cancellationReason: string): Observable<any> {
    const payload = { cancellationReason };
    return this._http.put<any>(`${this._baseUrl}/${this._controllerName}/${id}/cancel`, payload)
      .pipe(catchError(this.handleErrors));
  }

  getCancelledWorkOrders(): Observable<any> {
    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}/cancelled`)
      .pipe(catchError(this.handleErrors));
  }

  /**
   * 🆕 Obtiene TODAS las órdenes de trabajo (activas + anuladas)
   * @returns Observable con la lista completa de órdenes
   */
  getAllIncludingCancelled(): Observable<any> {
    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}/all-including-cancelled`)
      .pipe(catchError(this.handleErrors));
  }

  /**
   * Descarga el PDF de la Orden de Trabajo
   * @param id ID de la orden de trabajo
   * @returns Observable con el archivo Blob
   */
  downloadPdf(id: number): Observable<Blob> {
    return this._http.get(`${this._baseUrl}/${this._controllerName}/${id}/pdf`, { responseType: 'blob' })
      .pipe(catchError(this.handleErrors));
  }

  /**
   * 🆕 Obtiene órdenes de trabajo con paginación, búsqueda y filtros del lado servidor
   */
  getWorkOrdersPaged(parameters: any): Observable<any> {
    let params = new HttpParams();
    
    // Paginación
    if (parameters.pageNumber !== undefined && parameters.pageNumber !== null) {
      params = params.append('pageNumber', parameters.pageNumber.toString());
    }
    if (parameters.pageSize !== undefined && parameters.pageSize !== null) {
      params = params.append('pageSize', parameters.pageSize.toString());
    }
    
    // Búsqueda
    if (parameters.searchTerm) {
      params = params.append('searchTerm', parameters.searchTerm);
    }
    
    // Ordenamiento
    if (parameters.sortBy) {
      params = params.append('sortBy', parameters.sortBy);
    }
    if (parameters.sortOrder) {
      params = params.append('sortOrder', parameters.sortOrder);
    }
    
    // Filtros de fecha
    if (parameters.startDate) {
      params = params.append('startDate', parameters.startDate.toISOString());
    }
    if (parameters.endDate) {
      params = params.append('endDate', parameters.endDate.toISOString());
    }
    if (parameters.dateType) {
      params = params.append('dateType', parameters.dateType);
    }
    
    // Filtros de estado
    if (parameters.cancellationFilter) {
      params = params.append('cancellationFilter', parameters.cancellationFilter);
    }
    
    // Filtros específicos - usar verificación más segura para números
    if (parameters.status !== undefined && parameters.status !== null) {
      params = params.append('status', parameters.status.toString());
    }
    if (parameters.thirdPartyId !== undefined && parameters.thirdPartyId !== null) {
      params = params.append('thirdPartyId', parameters.thirdPartyId.toString());
    }
    if (parameters.projectId !== undefined && parameters.projectId !== null) {
      params = params.append('projectId', parameters.projectId.toString());
    }
    if (parameters.minAmount !== undefined && parameters.minAmount !== null) {
      params = params.append('minAmount', parameters.minAmount.toString());
    }
    if (parameters.maxAmount !== undefined && parameters.maxAmount !== null) {
      params = params.append('maxAmount', parameters.maxAmount.toString());
    }

    // Filtro por ID
    if (parameters.filterId !== undefined && parameters.filterId !== null) {
      params = params.append('filterId', parameters.filterId.toString());
    }

    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}/paged`, { params })
      .pipe(catchError(this.handleErrors));
  }

  private handleErrors(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.log("Ocurrio un error", error.error.message);
    } else {
      console.log(`Ocurrio un error ${error.status}, ${error.error}`);
    }
    return throwError(() => new Error('Algo salió mal; por favor, intente nuevamente más tarde.'));
  }
}
